export const ARTICLES_SORT_OPTIONS = [
  { value: 'default', label: 'Default' },
  { value: 'latest', label: 'Latest' },
  { value: 'oldest', label: 'Oldest' },
];
